<template>
<div
    class="action-container"
>
    
    <m-action-chip
        icon="mdi-information-slab-circle-outline"
        line1="Notice"
        line2="Beta"
        line3="Development in progress"
        state="regular"
    />

    <m-action-chip
        icon="mdi-account-outline"
        line1="Commerce7 Customer"
        line2="Megan Secor & Jarold Secur"
        line3="Scottsdale, AZ, US"
        clickable
        state="regular"
    />

    <m-action-chip
        icon="mdi-account-outline"
        line1="Commerce7 Customer"
        line2="No profile"
        line3="Click to create a profile"
        clickable

        state="light"
    />

    <m-action-chip
        icon="mdi-diamond-stone"
        line1="Club Member"
        line2="12 Years, 11 Months"
        line3="Library Wine Subscription"
        clickable
        state="regular"
    />

    <m-action-chip
        icon="mdi-diamond-stone"
        line1="Former Club Member"
        line2="Left 3 Months Ago"
        line3="Library Wine Subscription"
        clickable
        state="light"
    />

    <m-action-chip
        icon="mdi-diamond-stone"
        line1="Club Member"
        line2="Not Yet"
        line3="Click Here to Edit Memberships"
        clickable
        state="light"
    />

    <m-action-chip
        icon="mdi-star-outline"
        line1="Lifetime Value"
        line2="$0"
        line3="No orders"
        clickable
        state="light"
    /> 

    <m-action-chip
        icon="mdi-alert-outline"
        line1="Commerce7 Customer"
        line2="Failed to fetch customer"
        line3="Please try again later"
        state="error"
    /> 

     <m-action-chip
        icon="mdi-package-variant-closed"
        line1="Wineshipping"
        line2="No recent shipment(s)"
        line3="As of Feb 16, 2025"
        state="light"
    />

    <m-action-chip
        icon="mdi-package-variant-closed"
        line1="Wineshipping"
        line2="Delivery Attempt Failed"
        line3="1ZX834J8338484"
        state="regular"
    />

</div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.action-container
{
    display: flex; 
    flex-wrap: wrap;
    gap: 10px;
}
</style>